// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2Y8CL","label":"CategoryService_label__3GECZ","location":"CategoryService_location__SVmjv"};